import axios from 'axios';
import axiosSetup from '@/interceptors/axios.interceptor';

const axiosIns = axios.create(
  {
    baseURL: process.env.VUE_APP_API_GATEWAY,
    withCredentials: true,
  },
);
axiosSetup(axiosIns);

/**
 * Отфильтровать json по query params
 * @param  {any[]|object} target
 * @param  {any} query
 * @param  {string} returnType тип возвращаемого объекта
 */
const filterWithQuery = (target: any[] | object, query: object, returnType?: string) => {
  if (!query) {
    return target;
  }
  if (target instanceof Array) {
    if (returnType === 'object') {
      return target.find((el) => checkObjectWithQuery(el, query));
    } else {
      return target.filter((el) => checkObjectWithQuery(el, query));
    }
  } else if ( checkObjectWithQuery(target, query) ) {
    return target;
  }
  return target;
};

/**
 * Подходит ли объект по query параметрам
 * @param  {any} obj фильтруемый объект
 * @param  {any} query
 */
const checkObjectWithQuery = (obj: any, query: any) => {
  let flag = true;
  Object.keys(query).forEach((key) => {
    if (query[key] instanceof Array) {
      for (const el of query[key]) {
        if (obj[key].includes(el)) {
          return;
        }
      }
      return flag = false;
    } else if (obj[key] instanceof Object) {
      if (obj[key]._id !== query[key]) {
        return flag = false;
      }
    } else if (obj[key] !== query[key]) {
      return flag = false;
    }
  });
  return flag;
};

const get = async (url: string, importPath: string, query?: object, returnType?: string) => {
  if (process.env.NODE_ENV === 'single' || process.env.NODE_ENV === 'test') {
    return import(`@/../json/${importPath}`).then( ({default: res}) => filterWithQuery(res, query!, returnType) );
  } else {
    return axiosIns.get(url);
  }
};

const post = async (url: string, body: object) => {
  if (process.env.NODE_ENV === 'single' || process.env.NODE_ENV === 'test') {
    return { message: 'OK' } as any;
  } else {
    return axiosIns.post(url, body);
  }
};

const put = async (url: string, body: object) => {
  if (process.env.NODE_ENV === 'single' || process.env.NODE_ENV === 'test') {
    return { message: 'OK' } as any;
  } else {
    return axiosIns.put(url, body);
  }
};

const patch = async (url: string, body: object) => {
  if (process.env.NODE_ENV === 'single' || process.env.NODE_ENV === 'test') {
    return { message: 'OK' } as any;
  } else {
    return axiosIns.patch(url, body);
  }
};

const destroy = async (url: string) => {
  if (process.env.NODE_ENV === 'single' || process.env.NODE_ENV === 'test') {
    return { message: 'OK' } as any;
  } else {
    return axiosIns.delete(url);
  }
};

export default {
  get,
  post,
  put,
  patch,
  delete: destroy,
};
